import {callApi} from "./api";
import * as contract from "../contract";

// The signed-in person's email settings (see contract/account.ts).
export const getEmailNotificationsQuery = async () =>
    (await callApi(contract.account.getEmailNotifications)).emailNotifications;

export const updateEmailNotificationsQuery = async (overdue: boolean) =>
    (await callApi(contract.account.updateEmailNotifications, {
        body: { overdue, timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone },
    })).emailNotifications;
